import {
  combineHexWithOpacity,
  getHexColorFromAlpha,
  getOpacityFromHex
} from "./../wix-rich-content-common/Utils/color-utils.js";
function resolveBackwardCompatOverlay(color, imageOpacity, opacityMax) {
  const inverted = (opacityMax - imageOpacity) / opacityMax;
  const baked = getOpacityFromHex(color) / 100;
  return combineHexWithOpacity(getHexColorFromAlpha(color), inverted * baked * 100) ?? color;
}
export {
  resolveBackwardCompatOverlay
};
//# sourceMappingURL=resolve-backward-compat-overlay.js.map
